import { __awaiter } from "tslib";
import ApiManager from '@/managers/apimanagers';
export const useStakingList = () => {
    const _error = (err) => Promise.reject(err);
    const getStakingList = (id) => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield ApiManager.get(`/crypto-staking-funds`, { memberID: id }).catch(_error);
        return data;
    });
    const cancelStakingFund = (stakingFundsID, memberID) => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield ApiManager.post(`/cancel-crypto-staking-funds`, {
            stakingFundsID: stakingFundsID,
            memberID: memberID,
        }).catch(_error);
        return data;
    });
    return { useStakingList, getStakingList, cancelStakingFund };
};
